import api from './api';

export const getHolidayAllowance = async (userId, year) => {
    const res = await api.get(`/HolidayAllowance/user/${userId}/year/${year}`);
    return res.data;
};

export const getHolidayAllowanceOverview = async (year) => {
    const res = await api.get(`/HolidayAllowance/overview/${year}`);
    return res.data;
};

export const upsertHolidayAllowance = async (userId, year, { base_allowance, extra_days, extra_reason }) => {
    const res = await api.put(`/HolidayAllowance/user/${userId}/year/${year}`, {
        base_allowance,
        extra_days,
        extra_reason,
    });
    return res.data;
};
